import React from 'react';


export default function Copyright({ className }) {
    return <div className={`text-center text-white  ${className}`}>
        Copyright &copy; Autoscope Technology 2023
    </div>
}
